import React from 'react';
import RichTextEditorUniversal from "../../../../../core/gd-components/editor-universal/editor-universal";
import {RTFVersion} from "../../../../../core/gd-components/editor/@type";

type Props = {
    title               : string
    expanded?           : boolean
    data                : any

}

export default function MessageDebugItemSubitems(props: Props) {

    const [expanded, setExpanded] = React.useState(props.expanded);

    const toggleExpanded = () => {
        setExpanded(!expanded);
    }

    const isInstructionsMarkdown = props.title === "instructions" && typeof props.data === "string"

    return (
        <>
            <div className="flex-row-left-center m-b-10 m-t-10 m-l-15" onClick={toggleExpanded}>
                <div className={Classes(expanded ? "i5-big-angle-down" : "i5-big-angle-right", "fs-10", "m-r-5")}></div>
                <div className="ui5-txt-default-tiny" >{props.title}</div>
            </div>

            <div className="m-l-15" style={{maxWidth: "100%", overflow: "wrap", wordBreak: "break-word"}}>
                {expanded && (
                    isInstructionsMarkdown
                        ? <RichTextEditorUniversal className   = {Classes('gd-textarea-rte')}
                                                   editable    = {false}
                                                   messageText = {props.data}
                                                   messageRTF  = {{markdown: props.data, v: RTFVersion.MARKDOWN}}/>
                        : JSON.stringify(props.data, (key, value)=> {
                            return value
                        }, 2)
                )}
            </div>

        </>
    );
}
